import { ofType } from "redux-observable";
import { switchMap, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { ActionsObservable } from "redux-observable";
import { toast } from "react-toastify";
import { API_URL } from "../../config/settings";
import { Headers } from "../../utilites/Headers";
import { FinanceStats } from "../../actions/appExpandedActions/finances";

export const getFinanceAggregatedStatsEpic = (action$) =>
  action$.pipe(
    ofType(FinanceStats.GET_FINANCE_AGGREGATED_STATS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-finances/aggregated-stats`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: FinanceStats.GET_FINANCE_AGGREGATED_STATS_SUCCESS,
              payload: response.payload,
            });
            // ✅ ADD: Call onSuccess callback if provided
            if (payload?.onSuccess) {
              payload.onSuccess(response.payload);
            }
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load finance stats");
            // ✅ ADD: Call onError callback if provided
            if (payload?.onError) {
              payload.onError(err);
            }
            obs.complete();
          })
        )
      )
    )
  );

export const getWalletsEpic = (action$) =>
  action$.pipe(
    ofType(FinanceStats.GET_WALLETS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-finances/wallets/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: FinanceStats.GET_WALLETS_SUCCESS,
              payload: response.payload,
            });
            // ✅ ADD: Call onSuccess callback if provided
            if (payload?.onSuccess) {
              payload.onSuccess(response.payload);
            }
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load wallets");
            // ✅ ADD: Call onError callback if provided
            if (payload?.onError) {
              payload.onError(err);
            }
            obs.complete();
          })
        )
      )
    )
  );

export const getTransactionsEpic = (action$) =>
  action$.pipe(
    ofType(FinanceStats.GET_TRANSACTIONS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-finances/transactions/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: FinanceStats.GET_TRANSACTIONS_SUCCESS,
              payload: response.payload,
            });
            // ✅ ADD: Call onSuccess callback if provided
            if (payload?.onSuccess) {
              payload.onSuccess(response.payload);
            }
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load transactions");
            // ✅ ADD: Call onError callback if provided
            if (payload?.onError) {
              payload.onError(err);
            }
            obs.complete();
          })
        )
      )
    )
  );

export const getSharedWalletsEpic = (action$) =>
  action$.pipe(
    ofType(FinanceStats.GET_SHARED_WALLETS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-finances/wallet-invitations/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: FinanceStats.GET_SHARED_WALLETS_SUCCESS,
              payload: response.payload,
            });
            // ✅ ADD: Call onSuccess callback if provided
            if (payload?.onSuccess) {
              payload.onSuccess(response.payload);
            }
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load shared wallets");
            // ✅ ADD: Call onError callback if provided
            if (payload?.onError) {
              payload.onError(err);
            }
            obs.complete();
          })
        )
      )
    )
  );

export const getBankIntegrationsEpic = (action$) =>
  action$.pipe(
    ofType(FinanceStats.GET_BANK_INTEGRATIONS),
    switchMap(({ payload }) =>
      ajax({
        url: `${API_URL}/admin/app-finances/bank-accounts/list`,
        method: "POST",
        headers: Headers.get_auth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) =>
          ActionsObservable.create((obs) => {
            obs.next({
              type: FinanceStats.GET_BANK_INTEGRATIONS_SUCCESS,
              payload: response.payload,
            });
            // ✅ ADD: Call onSuccess callback if provided
            if (payload?.onSuccess) {
              payload.onSuccess(response.payload);
            }
            obs.complete();
          })
        ),
        catchError((err) =>
          ActionsObservable.create((obs) => {
            if (err.status === 401) {
              localStorage.clear();
              window.location.href = "/login";
            }
            toast.error(err?.response?.error || "Failed to load bank integrations");
            // ✅ ADD: Call onError callback if provided
            if (payload?.onError) {
              payload.onError(err);
            }
            obs.complete();
          })
        )
      )
    )
  );